import gql from 'graphql-tag';

export const GET_AFTERMARKET_PRODUCT_BY_ID = gql`
  query GetAftermarketProductById($accountId: ID!, $productId: ID!) {
    aftermarketProductById(accountId: $accountId, productId: $productId) {
      aftermarketProductId
      accountIdCreatedBy
      productName
      partnerLinks {
        name
        partnerLinkId
      }
      aftermarketVendorApiChannel
      productCategory
      productType
      criteria
      productDescriptionExternal
      productDescriptionInternal
      createdDateTime
      productLogoUrl
      addons {
        aftermarketProductId
        productName
      }
      externalId
      firstDateAvailable
      lastDateAvailable
      isActive
      aftermarketProductCatalogDetails {
        productSummary
        limitationsOfLiability
        eligibilityAndInclusions
        legalDisclaimer
        paragraphDescription
        coverageDetails
      }
    }
  }
`;
